import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

type DetailGridGap = 'sm' | 'md' | 'lg'

interface DetailGridProps {
    children: ReactNode
    columns?: 2 | 3 | 4
    gap?: DetailGridGap
    responsive?: boolean
    className?: string
    'data-testid'?: string
}


const GAP_CLASS: Record<DetailGridGap, string> = {
    sm: 'gap-2',
    md: 'gap-4',
    lg: 'gap-6',
}


export function DetailGrid({children, columns = 2, gap = 'md', responsive = true, className, 'data-testid': testId}: DetailGridProps) {
    /* eslint-disable i18next/no-literal-string -- CSS class constants */
    const colClass = responsive
        ? {
              2: 'grid-cols-1 md:grid-cols-2',
              3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
              4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4',
          }[columns]
        : {
              2: 'grid-cols-2',
              3: 'grid-cols-3',
              4: 'grid-cols-4',
          }[columns]
    /* eslint-enable i18next/no-literal-string */

    return (
        <div
            className={cn('grid', GAP_CLASS[gap], colClass, className)}
            data-testid={testId}
        >
            {children}
        </div>
    )
}
